import React from "react";

import NumberFormat from "react-number-format";

import CstmTextField from "./CstmTextField";

const PercentField = (props) => {
  return (
    <React.Fragment>
      <CstmTextField
        {...props}
        InputProps={{
          inputComponent: NumberFormatCustom,
        }}
      />
    </React.Fragment>
  );
};

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      isNumericString
      suffix="%"
    />
  );
};

export default PercentField;



// WEBPACK FOOTER //
// ./src/components/PercentField.js